import React from 'react';
import PropTypes from 'prop-types';

import { fromJS } from 'immutable';
import { get } from 'lodash-es';

import ItemField from '../../../Components/ItemField/ItemField';
import withToggleView from '../../../Components/ToggleView/ToggleView';
import EditContacts from './EditContacts';
import { configContacts } from '../config';

const BlockContacts = ({ party, strings, i18n, mode, setViewMode, id, updatePartyContacts }) => {
  const { fields, initialValues } = configContacts({ party, strings });

  const getContactField = contact => {
    const { type, value, id: contactId } = contact;
    switch (type) {
      case 'phone':
        return (
          <ItemField
            label={strings['party.edit.field.phone.label'] || 'Phone'}
            value={party.phone}
            name={type}
            key={`phone-${contactId}`}
            optional
          />
        );
      case 'mobile':
        return (
          <ItemField
            label={strings['party.edit.field.mobile.label'] || 'mobile'}
            value={party.mobile}
            name={type}
            key={`mobile-${contactId}`}
            optional
          />
        );
      case 'email':
        return (
          <ItemField
            label={strings['party.edit.field.email.label'] || 'Email'}
            value={party.email}
            name={type}
            key={`email-${contactId}`}
            type="email"
            optional
          />
        );
      default:
        return <ItemField label={type} value={value} name={type} key={`item-${contactId}`} optional />;
    }
  };

  const contentViewBlock = contactMechanisms => (
    <div className="content">
      {Array.isArray(contactMechanisms) ? contactMechanisms.map(contact => getContactField(contact)) : undefined}
    </div>
  );

  const contentEditBlock = (
    <div className="content" key={`contacts-${id}`}>
      <EditContacts
        id={party.id}
        initialValues={initialValues}
        fields={fields}
        updateContacts={updatePartyContacts}
        setViewMode={setViewMode}
        buttons={{
          submit: strings['party.edit.block.button.submit.label'] || 'Enregistrer les modifications',
          add: strings['party.edit.block.button.add-contact.label'] || 'Ajouter un contact',
        }}
        tooltips={{
          remove: strings['party.edit.block.tooltip.remove-contact.label'] || 'Supprimer cette adresse',
          insert: strings['party.edit.block.tooltip.insert-contact.label'] || 'Insérer une nouvelle adresse',
        }}
        locale={get(i18n, 'lang', 'fr')}
      />
    </div>
  );

  const contactMechanisms = []
  for(let k of ['mobile', 'phone', 'email']) {
    if (party[k]) {
      contactMechanisms.push({'type': k, 'value': party[k]})
    }
  }
  return mode === 'view' ? <>{contentViewBlock(contactMechanisms)}</> : <>{contentEditBlock}</>;
};

BlockContacts.propTypes = {
  strings: PropTypes.objectOf(PropTypes.string),
  // eslint-disable-next-line react/forbid-prop-types
  party: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  i18n: PropTypes.object,
  mode: PropTypes.oneOf(['edit', 'view']).isRequired, // HOC withToggleView
  setViewMode: PropTypes.func.isRequired, // HOC withToggleView
  updatePartyContacts: PropTypes.func,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

BlockContacts.defaultProps = {
  party: {},
  strings: {},
  i18n: fromJS({}),
  updatePartyContacts: params => {
    // eslint-disable-next-line no-console
    console.log('updateContacts', params);
  },
};

const config = {
  title: 'party.edit.block.contacts.label',
  defaultTitle: 'Contacts',
  name: 'addressescontacts',
  active: true,
};

export default withToggleView(BlockContacts, config);
